module.exports = __webpack_public_path__ + "media/customizations/meridiana/logo-4d6217dfe62c48a305cd57c68efc9ce7.png";